import * as Factory from 'factory.ts'
import faker from 'faker'

import { StripeAddressMock } from './stripeAddress.factory'
import { UserMock } from './user.factory'
import {
  type StripeAccount,
  type StripeAccountBalance,
  type StripeAccountBalances,
  type StripeAccountBalanceSourceType,
  type StripeAccountBalanceWithSourceType,
} from '../../models/StripeAccount'

export const StripeAccountBalanceMock =
  Factory.Sync.makeFactory<StripeAccountBalance>({
    amount: Factory.each(() => faker.finance.amount()),
    currency: 'USD',
  })

export const StripeAccountBalanceSourceTypeMock =
  Factory.Sync.makeFactory<StripeAccountBalanceSourceType>({
    bank_account: parseInt(faker.finance.account(), 10),
    card: faker.random.number(),
  })

export const StripeAccountBalanceWithSourceTypeMock =
  Factory.Sync.makeFactory<StripeAccountBalanceWithSourceType>({
    ...StripeAccountBalanceMock.build(),
    source_types: StripeAccountBalanceSourceTypeMock.build(),
  })

export const StripeAccountBalancesMock =
  Factory.Sync.makeFactory<StripeAccountBalances>({
    allocated: StripeAccountBalanceMock.buildList(1),
    available: StripeAccountBalanceWithSourceTypeMock.buildList(1),
    pending: StripeAccountBalanceWithSourceTypeMock.buildList(1),
    remaining: StripeAccountBalanceMock.buildList(1),
  })

export const StripeAccountMock = Factory.Sync.makeFactory<StripeAccount>({
  address: StripeAddressMock.build(),
  balance: StripeAccountBalancesMock.build(),
  stripe_account_id: faker.finance.account(),
  owner: UserMock.build(),
})
